<template>
  <div class="post-webwidget-v2-now-playing-image-wrapper">
    <template v-if="imageSrc">
      <img
        v-if="isImageReady"
        :class="imageClassObject"
        :src="imageSrc"
        :width="width"
        :height="height"
      />
      <div
        v-else
        class="post-webwidget-v2-now-playing-image-loader"
      >
        Loading image...
      </div>
    </template>
    <template v-else>
      <img
        :class="imageClassObject"
        :src="noImagePlaceholder"
        :width="width"
        :height="height"
      />
    </template>
  </div>
</template>

<script>
export default {
  name: 'now-playing-image',
  props: {
    width: Number,
    height: Number,
    compactOnMobile: {
      type: Boolean,
    },
    imageSrc: {
      type: String,
    },
  },
  data() {
    return {
      noImagePlaceholder: `https://via.placeholder.com/${this.width}x${this.height}.png?text=No Image`, // Temporary: Same dimensions as episode images.
      isImageReady: false,
      imageClassObject: {
        'post-webwidget-v2-now-playing-image': true,
        'post-webwidget-v2-now-playing-image--compact-on-mobile': this.compactOnMobile,
      },
    };
  },
  methods: {
    downloadImage() {
      const image = new Image();
      image.src = this.imageSrc;
      if (image.complete) {
        // Found in cache
        this.isImageReady = true;
      } else {
        // Not found in cache
        image.onload = () => {
          // Finished downloading
          this.isImageReady = true;
        };
      }
    },
  },
  ready() {
    this.downloadImage();
  },
  watch: {
    imageSrc() {
      this.downloadImage();
    },
  },
};
</script>


<style lang="scss" scoped>
@import '../assets/variables-v2';
.post-webwidget-v2-now-playing-image-wrapper {
  width: 100%;

  .post-webwidget-v2-now-playing-image {
    width: 100%;
    height: 100%;
    border-radius: 2.5px; // half of $borderRadius

    @media screen and (max-width: $mobileBreakpoint) {
      margin-top: -0.5px; // Border radius margin fix
      border-top-left-radius: $borderRadius;
      border-top-right-radius: $borderRadius;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }

    &--compact-on-mobile {
      border-radius: $borderRadius; // Make sure all sides have a border radius
    }

    &-loader {
      display: flex;
      width: 100%;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>


// WEBPACK FOOTER //
// NowPlayingImage.vue?b2aa2bda